import { ReactNode, useContext, useEffect, useMemo, useRef, useState } from "react";
import { StampType } from "../../components/Stamp";
import { StampCollection } from "../../components/StampCollection";
import { Outlet, useNavigate } from "react-router";
import manwithplan from "url:../../assets/isp/Man with a Plan.png"
import '../../styles/wtrok.css';
import { WTROKPLY } from "./WTROKPLY";
import WTROKPROV, { WTROKPROVCON } from "./WTROKPROV";
import PlayerProvider from "../../providers/PlayerProvider";
import { SITE_INFO_WTRK } from "../../providers/SitesProvider";

export function WTROK0 () {
    const player = useContext(PlayerProvider.context);

    useEffect(() => {
        player.unlockSite(SITE_INFO_WTRK.key);
    }, []);

    const page = useMemo(() => {
        return <WTROKPROV>
            <div className="wtrok-page gap-none">
                <WTROKSidebar />
                <div className="v-box wtrok-content">
                    <WTROKLines />
                    <div className="height-128" />
                    <div className="h-box width-auto padding-8 text-18 font-treb justify-end">The official sound of Triple Oaks</div>
                    <div className="v-box width-100p center-all">
                        <Outlet />
                    </div>
                </div>
                <div className="wtrok-footer bg-wtrok-purple h-box center-all gap-64 text-18 font-soon z-3">
                    <a href="/wtrok/airtimes">Air Times</a>
                    <a href="/wtrok/about">About Our Station</a>
                    <a href="/wtrok/music">What's Playing</a>
                    <a href="/wtrok/sweepstakes">Sweepstakes</a>
                </div>
            </div>
        </WTROKPROV>
    }, []);

    return page;
}

function WTROKHeader() {
    const nav = useNavigate();
    return <div className="v-box width-100p bg-wtrok-darkred center-all">
        <div className="height-16" />
        <div className="v-box justify-end height-96">
            <h1 className="text-white text-wtrok-yellow font-treb text-64 margin-none padding-none" onClick={() => {
                nav("/wtrok");
            }}>WTROK</h1>
        </div>
        <div className="bg-wtrok-purple height-16 width-100p" />
    </div>
}

function WTROKSidebar() {
    const context = useContext(WTROKPROV.context);

    return <div className="v-box wtrok-sidebar z-1">
        <WTROKHeader />
        <div className="bg-wtrok-darkred flex-spacing font-treb v-box justify-space align-center">
            <div className="height-16"/>
            <WTROKPLY />
            <div className="v-box margin-32 padding-16 bg-wtrok-yellow text-wtrok-purple wtrok-box-border center-all">
                <p>We're ALWAYS on the pulse of TRIPLE OAKS. We know who you are -- yes, YOU -- and we're going to play what you NEED TO HEAR.</p>
                <p>Be sure to tune in! On your way to work at the factory? WTROK. Waiting in the parking lot for your wife? WTROK. Drinking a beer alone in the garage? WTROK.</p>
                <p>WTROK is always there bringing the tunes straight from our discs through the radio waves to your hungry ears. Let us feed you! Open wide!</p>
            </div>
            <div className="v-box pos-rel center-all">
                <img src={manwithplan} className="width-128" />
                {/* <div className="pos-abs font-soon padding-8 bg-white text-wtrok-purple border-black border-radius-4" style={{ top: 8, right: 8 }}>I Love WTROK</div> */}
            </div>
            <div className="font-soon center-all v-box">
                <div>Friends of WTROK:</div>
                <StampCollection stamps={[
                    StampType.TROK,
                    StampType.TacoBongo
                ]} />
            </div>
            <div className="height-16" />
        </div>
    </div>
}

function WTROKLines() {
    return <div className="v-box width-100p wtrok-header z-3">
        <div className="bg-wtrok-dark height-48" />
        <div className="bg-wtrok-yellow height-16 width-100p" />
        <div className="bg-wtrok-orange height-16 width-100p" />
        <div className="bg-wtrok-red height-16 width-100p" />
        <div className="bg-wtrok-darkred height-16 width-100p" />
        <div className="bg-wtrok-purple height-16 width-100p" />
    </div>    
}